import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import { MDBDataTable } from "mdbreact"
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Modal,
  Container,
  Button,
  CardSubtitle,
} from "reactstrap"
import { Link } from "react-router-dom"

import logolightImg from "../../assets/images/notification/error.png"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
// import "../../../src/assets/scss/datatables.scss"

export default function TransactionHistory() {
  const [modal_center, setmodal_center] = useState(false)

  function tog_center() {
    setmodal_center(!modal_center)
    removeBodyCss()
  }
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  const data = {
    columns: [
      {
        label: "User Name",
        field: "UserName",
        sort: "asc",
        attributes: { width: "25%" },
      },
      {
        label: "Amount",
        field: "Amount",
        sort: "asc",
        attributes: { width: "15%" },
      },
      {
        label: "Payment Id",
        field: "PaymentId",
        sort: "asc",
        attributes: { width: "15%" },
      },
      {
        label: "Payment Date",
        field: "PaymentDate",
        sort: "asc",
        attributes: { width: "15%" },
      },
      {
        label: "Payment Method",
        field: "PaymentMethod",
        sort: "asc",
        attributes: { width: "15%" },
      },
      {
        label: "Payment by",
        field: "Paymentby",
        sort: "asc",
        attributes: { width: "15%" },
      },
    ],
    rows: [
      {
        UserName: "Nishit Kachiya",
        Amount : "€50.49",
        PaymentId: "ID-PN2043854356	",
        PaymentMethod: "UPI",
        Paymentby: "Paypal",
        PaymentDate: "23/06/2021",
      },
    ],
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Transaction History | Virtual Supermarket</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}

          {/* <Button
            href="/add-notification"
            color="primary"
            style={{ float: "right", marginTop: "1.9rem" }}
          >
            Add Notification
          </Button> */}

          <Breadcrumbs
            maintitle="Dashboard"
            title="Transaction History"
            breadcrumbItem="Transaction History"
          />

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <MDBDataTable
                    responsive
                    bordered
                    noBottomColumns
                    theadColor="btn-primary"
                    data={data}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal
        isOpen={modal_center}
        toggle={() => {
          tog_center()
        }}
        centered={true}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Last Minute Deal starting</h5>
          <button
            type="button"
            onClick={() => {
              setmodal_center(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body pt-5 pb-5">
          <center><img src={logolightImg} alt="logo" height="150" /></center>
        </div>
      </Modal>
    </React.Fragment>
  )
}
